export const BASE_API_URL = "https://demo2.uptech-sensing.com/api/v1";
export const URL = "demo2.uptech-sensing.com";
//export const BASE_API_URL = "http://192.168.1.51:8000/api/v1";
//export const BASE_API_URL = "http://10.9.0.34:8000/api/v1";

export const AUTH_API_ENDPOINT = "/auth";
export const IS_ONLINE = true;
export const MAP_TYPES = [
  {
    label: "map.regular",
    value: "regular",
    tileLayer: IS_ONLINE ? `http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}` : `${BASE_API_URL}/images/{z}/{x}/{y}`,
  },
  {
    label: "map.satellite",
    value: "satellite",
    tileLayer: "http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}",
  },
  {
    label: "map.terrain",
    value: "terrain",
    tileLayer: "http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}",
  },
];
export const webTitle = "Cable Monitor";

export const ESPECIAL_ACCESS = false;

export const lista = [
  0.003525 / 4,
  0.003 / 4,
  0.002475 / 4,
  0.00195 / 4,
  0.00145 / 4,
  0.0009 / 4,
  0.00045 / 4,
  0.000225 / 4,
];
export const rango = [11, 12, 13, 14, 15, 16, 17, 18];
//export const BASE_API_URL = "https://kerkini.uptech-sensing.com/api/v1";
//export const URL = "kerkini.uptech-sensing.com";
////export const BASE_API_URL = "http://192.168.1.51:8000/api/v1";
////export const BASE_API_URL = "http://10.9.0.34:8000/api/v1";
//
//export const AUTH_API_ENDPOINT = "/auth";
//export const IS_ONLINE = true;
//export const MAP_TYPES = [
//  {
//    label: "map.regular",
//    value: "regular",
//    tileLayer: IS_ONLINE ? `http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}` : `${BASE_API_URL}/images/{z}/{x}/{y}`,
//  },
//  {
//    label: "map.satellite",
//    value: "satellite",
//    tileLayer: "http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}",
//  },
//  {
//    label: "map.terrain",
//    value: "terrain",
//    tileLayer: "http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}",
//  },
//];
//

export const auxReports = false;
